import {gql, useLazyQuery} from '@apollo/client'
import {useStatesAndHealthConditions} from '../../store/hooks/breadCrumbs'
import {getState} from '../../shared/helpers/getState'
import {useFilterManagement} from '../../store/hooks/useFilterManagement'

export default function useQueryPopulationDistribution(dimension) {
  const PopulationDistribution = gql`
    query PopulationDistribution($filters: Filters, $dimension: String, $benefits: [BenefitEligibility]) {
      populationDistribution(filters: $filters, dimension: $dimension, benefits: $benefits) {
        binName
        binIndex
        count
        state
        percentage
      }
    }
  `

  const {getQueryParams, getOutreachParams} = useFilterManagement()
  const {filters} = useStatesAndHealthConditions()
  const selectedState = getState(filters)
  const appliedFilterParams = getQueryParams()

  // Get outreach params (benefits only for now)
  const outreach = getOutreachParams()
  const benefitsData = outreach.type === 'benefits' ? outreach.data : []

  const [conditionalDistributionQuery, {loading, error, data, refetch}] = useLazyQuery(PopulationDistribution, {
    variables: {
      filters: {
        ...appliedFilterParams,
        state: selectedState
      },
      dimension,
      benefits: benefitsData
    },
    skip: !dimension,
    partialRefetch: true,
    notifyOnNetworkStatusChange: true
  })

  return {loading, error, data, refetch, conditionalDistributionQuery}
}
